/**
 * Container — centers page content with a max-width and consistent padding.
 * Drop this inside a full-bleed page wrapper to constrain the content area.
 */

import { ReactNode, CSSProperties } from 'react';

interface ContainerProps {
  children: ReactNode;
  maxWidth?: number;
  style?: CSSProperties;
}

export default function Container({ children, maxWidth = 1240, style }: ContainerProps) {
  return (
    <div
      style={{
        maxWidth,
        margin: '0 auto',
        padding: '28px 28px 36px',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
